<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <br>
  <div class="content">
    <div class="due-diligence-container" [formGroup]="onboardingassessmentForm">
      <h2 class="section-title">Due Diligence Check</h2>
      <div formArrayName="documents">

        @for (item of dueDiligenceItems; track $index; let i = $index) {
        <div class="check-row" [formGroupName]="i">

          <div class="left-section">

            @if (item.url) {
            <a [href]="item.url" target="_blank" class="link-text">
              {{ item.label }}
            </a>
            }

            @if (!item.url) {
            <span class="plain-text">
              {{ item.label }}
            </span>
            }
          </div>

          <div class="col-md-3 text-end" formArrayName="attachements">
            @for(attachment of getAttachments(i).controls;track attachment; let j = $index){
            <div [formGroupName]="j">
              @let documentFilename = attachment.get('documentFilename');
              @if(isReadOnly() == false || iseditable()){
              <!-- Upload Button -->
              <label class="upload-btn" *ngIf="!documentFilename?.value">
                Upload Document

                <input type="file" multiple [id]="'documentFilename-' + i + '-' + j" accept=".pdf,.jpg,.jpeg,.png"
                  hidden (change)="onDocumentFileChange($event,i,j)" />
              </label>
              }
              <input type="text" formControlName="documentFilename" hidden>

              @if (documentFilename?.value) {
              <!-- Uploaded File Name -->
              <div class="file-container" *ngIf="documentFilename?.value">
                @if(isReadOnly() == false || this.iseditable()){
                <span class="file-name">{{ documentFilename?.value }}</span>
                <div class="action-buttons">
                  <button mat-icon-button color="warn" matTooltip="remove file" class="delete-btn"
                    (click)="removeFile('documentFilename','document',i,j)">✖</button>
                  @if(item.upload == 'Multiple' && j === getAttachments(i).length - 1){
                  <button mat-icon-button color="primary" matTooltip="Add file" (click)="addAttachment(i)">+</button>
                  }
                </div>
                }
              </div>
              }@else{
              @if(getAttachments(i).length > 1){
              <button mat-icon-button color="warn" matTooltip="remove upload" class="delete-btn"
                (click)="removeuploadfield(i,j)">✖</button>
              }
              }
              @if(j === getAttachments(i).length - 1){
              @if(item.file.length == 0){
              @if(isReadOnly()){
              @if(iseditable() == false){
              <button mat-stroked-button [disabled]="true">
                N/A
              </button>
              }
              }
              }@else{
              <button mat-stroked-button (click)="previewDoc(item)">
                View
              </button>
              }
              }
            </div>
            @if(documentFilename?.invalid && (documentFilename?.touched ||
            documentFilename?.dirty)){
            <mat-error>
              @if(documentFilename?.errors?.["required"]) {
              <span>{{message}}</span>
              }@else if(documentFilename?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(documentFilename?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
            }
            <!-- Files dropped from a multi-file selection: they never became attachments, so the
                 reason has to be reported for the check as a whole. -->
            @if (uploadErrors[i]?.length) {
            <mat-error class="upload-error">
              @for (uploadError of uploadErrors[i]; track $index) {
              <div>{{ uploadError }}</div>
              }
            </mat-error>
            }
          </div>
        </div>
        }
      </div>
      <div class="row">
        <div class="col-12">
          <h5 class="field-title">Remarks</h5>
        </div>
        <mat-label class="field-label"></mat-label>
        <mat-form-field class="text-field">

          <textarea matInput formControlName="remarks" placeholder="Enter text"></textarea>
        </mat-form-field>
      </div>

      <h5 class="field-title">Acknowledgement</h5>
      <div class="due-diligence-container container-fluid">
        <div class="row align-items-start">
          <mat-checkbox formControlName="declarationaccepted">I confirm that all required verification checks have
            been completed and supporting documents have been reviewed.</mat-checkbox>
          @if(this.onboardingassessmentForm.controls["declarationaccepted"].invalid
          && (this.onboardingassessmentForm.controls["declarationaccepted"].touched ||
          this.onboardingassessmentForm.controls["declarationaccepted"].dirty)
          ) {
          <mat-error>
            @if(this.onboardingassessmentForm.controls["declarationaccepted"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
          <div class="col-md-6">
            <label class="field-label">
              <!-- <mat-icon class="label-icon">star</mat-icon> -->
              Name of Onboarding person
            </label>

            <mat-form-field class="w-100">
              <input matInput formControlName="onboardingname" placeholder="Enter Onboarding person" readonly />
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <label class="field-label">
              <!-- <mat-icon class="label-icon">star</mat-icon> -->
              Date
            </label>

            <mat-form-field class="w-100">
              <input type="date" matInput formControlName="date" readonly />
            </mat-form-field>
          </div>
        </div>
        @if(this.errormessage != ''){
        <mat-error>

          <span>{{errormessage}}</span>
        </mat-error>
        }
      </div>
      @if(isReadOnly() == false){
      <div class="form-actions mt-4">
        <button class="save-btn  me-2" (click)="returnByRole()">
          <mat-icon>arrow_backward</mat-icon>
          <span>Return to Candidate update</span>
        </button>
        <button class="save-btn" type="button" (click)="saveAndContinue()">
          <span>Save</span>
        </button>
        <button class="save-btn" type="button" (click)="openConfirmDialog()"
          [disabled]="this.onboardingassessmentForm.invalid">
          <span>Submit</span>
        </button>
      </div>
      }
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          @if (selectedItemFiles.length) {
          <small class="text-muted">{{ selectedItemFiles[selectedFileIndex]?.name }}</small>
          }
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <!-- Every uploaded file for this check is listed here, so a multi-file upload is visible
           at a glance and any one of them can be brought into the viewer. -->
      @if (selectedItemFiles.length) {
      <div class="file-list">
        <span class="file-list-label">Uploaded files ({{ selectedItemFiles.length }})</span>
        <div class="file-tabs">
          @for (file of selectedItemFiles; track $index; let i = $index) {
          <button class="file-tab" [class.active]="selectedFileIndex === i" (click)="loadFile(i)"
            [matTooltip]="file.name">
            <span class="file-tab-index">{{ i + 1 }}.</span>
            <span class="file-tab-name">{{ file.name }}</span>
          </button>
          }
        </div>
      </div>
      }

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>